import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { trainingService } from '@/services/trainingService';
import { getRefreshConfig } from '@/config/refresh.config';

export const useTrainings = (filters: Record<string, unknown> = {}) => {
  return useQuery({
    queryKey: ['trainings', filters],
    queryFn: () => trainingService.list(filters),
    staleTime: 5 * 60 * 1000,
    ...getRefreshConfig('moderate'),
  });
};

export const useTraining = (idOrSlug: string | number | undefined) => {
  return useQuery({
    queryKey: ['training', idOrSlug],
    queryFn: () => trainingService.get(idOrSlug!),
    enabled: !!idOrSlug,
    staleTime: 5 * 60 * 1000,
  });
};

export const useCreateTraining = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (trainingData: Record<string, unknown>) => trainingService.create(trainingData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['trainings'] });
    },
  });
};

export const useUpdateTraining = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string | number; data: Record<string, unknown> }) =>
      trainingService.update(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['trainings'] });
      queryClient.invalidateQueries({ queryKey: ['training', variables.id] });
      queryClient.invalidateQueries({ queryKey: ['training'] });
    },
  });
};

export const useDeleteTraining = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string | number) => trainingService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['trainings'] });
    },
  });
};
